import { STORAGE_KEYS } from '@/constants/storageKeys';

export function clearAuthStorage() {
  localStorage.removeItem(STORAGE_KEYS.token);
  localStorage.removeItem(STORAGE_KEYS.refreshToken);
  localStorage.removeItem(STORAGE_KEYS.meInfo);
  localStorage.removeItem(STORAGE_KEYS.tokenExpiresAt);
}
